// define a base class for all pages
import { signString } from './lib/md5'

import { generateNonce, getFromApi, postToApi, putToApi, deleteToApi, signMap } from './lib/api'

function BasePage() {

  const accentsMap = new Map([
    ["A", "Á|À|Ã|Â|Ä"],
    ["a", "á|à|ã|â|ä"],
    ["E", "É|È|Ê|Ë"],
    ["e", "é|è|ê|ë"],
    ["I", "Í|Ì|Î|Ï"],
    ["i", "í|ì|î|ï"],
    ["O", "Ó|Ò|Ô|Õ|Ö"],
    ["o", "ó|ò|ô|õ|ö"],
    ["U", "Ú|Ù|Û|Ü"],
    ["u", "ú|ù|û|ü"],
    ["C", "Ç"],
    ["c", "ç"],
    ["N", "Ñ"],
    ["n", "ñ"]
  ]);

  const reducer = (acc, [key]) => acc.replace(new RegExp(accentsMap.get(key), "g"), key);

  const removeAccents = (text) => [...accentsMap].reduce(reducer, text || "");

  const provinceFromResponse = (response) => {

    let dept = response.principalSubdivision || ""

    //console.log("dept", dept)

    // remove departamento de and department
    dept = dept.replace('Departamento del', '')
    dept = dept.replace('Departamento de', '')

    //console.log("dept", dept)
    dept = dept.replace('Department')

    //console.log("dept", dept)

    return dept.trim()
  }

  const getCurrentUserLocation = (callback, onError) => {
    // Get location of user

    const success = position => {
      var url = `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${position.coords.latitude}&longitude=${position.coords.longitude}&localityLanguage=en`;

      $.get(url)
        .then(response => {
          //console.log("reverse lookup", response)

          let province = removeAccents(provinceFromResponse(response))
          let city = removeAccents(response.city)
          let country = removeAccents(response.countryName)

          callback(window.LatLon(position.coords.latitude, position.coords.longitude), city, province, country)

        })
        .catch(error => {
          console.log("Error converting location to address", error)
          if (onError) onError(error)
        })
    };

    const error = () => {
      console.log("Unable to retrieve your geolocation");
      if (onError) onError("Unable to retrieve your geolocation")
    };
    navigator.geolocation.getCurrentPosition(success, error);
  }

  const startCarousel = (items) => {
    const $ = window.jQuery

    let elem = $(".owl-carousel")

    items ||= []

    //console.log("startCarousel carousel elem", elem, items);

    if (elem.length > 0) {

      elem.owlCarousel(
        {
          responsive: {
            0: {
              items: 1,
            },
            600: {
              items: 1,
            },
            1000: {
              items: 2,
            },
            1200: {
              items: 3,
            },
          },
          items: items.length,
          lazyLoad: true,
          pagination: "false",
          loop: true,
          center: true,
          dots: true,
          loop: true,
          //margin: 10,
          autoplay: true,
          autoplayTimeout: 3000,
          autoplayHoverPause: true,
          nav: false,
          navText: ["<i class='icofont-thin-left'></i>", "<i class='icofont-thin-right'></i>"]
        }

      );
    }
  }

  const assetsRow = (business) => {

    let assets = window.carouselImages

    if (assets == null && business && business.Assets) {
      assets = business.Assets.map(a => a.url)
    }

    let data = assets.map((url, index) => {
      return (
        <div className="item" key={`carouselImg_${index}`}>
          <img src={url} style={{
            maxHeight: 200,
            minHeight: 200,
            maxWidth: 500,
            //objectFit: 'cover'
          }} />
        </div>
      )
    })

    if (data.length > 1) {
      return  carouselElement(data)
    } else if (business.banner && business.banner != "") {
      // return the business banner
      return (
        <div className="row logo-row">
          <div className="col centered"><img src={business.banner} style={{
            maxHeight: 200,
            minHeight: 100,
            maxWidth: 600,
            objectFit: 'cover'
          }} /></div>
        </div>
      )
    }

    return <></>

  }

  const carouselElement = (children) => {

    if (children && children.length > 1) {

      // return a carousel with the children
      setTimeout(() => startCarousel(children), 500)

      return (
        <div className="row p-2 my-3 offers-carousel">
          <div className="col-12 centered">
            <div className="owl-theme owl-carousel owl-carousel-five offers-interested-carousel">

              {children}

            </div>
          </div>
        </div>
      )
    }

    return <></>

  }

  const fixupPhone = (phone) => {
    if (phone.startsWith('+')) return phone;

    if (phone.startsWith('3') && phone.length === 10) return `+57${phone}`

    return `+${phone}`
  }

  const fixupEmail = (email) => {
    if (email === undefined) return ""

    return email.toLowerCase().trim()
  }

  const generateCode = (data, success, error) => {
    //console.log("doSendCodes")

    let url = "/api/v1/user/code_for_credentials"

    //console.log("doSendCode data", data)

    $.ajax({
      url: url,
      type: "POST",
      data: data,
    })
      .then((response) => {
        //console.log("code_for_credentials response", response)
        alert("Por favor revise su correo electrónico y WhatsApp para obtener el código de verificación.")
        if (success) success(response)

      })
      .catch((response) => {
        console.log("code_for_credentials response", response)
        let txt = response.responseText

        if (txt == "email or phone mismatch") {
          alert("Algunos datos son incorrectos, por favor utilice el correo electrónico y número de teléfono que utilizó anteriormente")
        } else if (txt == "user not found") {
          alert("Algunos datos son incorrectos, por favor revisarlo")
        } else if (txt == "code does not match") {
          alert("El código de verificación no es corecto, por favor revisarlo")
        }

        if (error) error(response)
      })
  }

  const isEmpty = (str) => {
    return str == null || str == ""
  }

  const twitterButton = (business) => {
    if (isEmpty(business.twitter)) return <></>

    if (business.twitter.startsWith("https")) {
      return (
        <a href={business.twitter}>
          <span className="social-button" >
            <i className="zmdi zmdi-twitter" style={{ fontSize: 30 }}></i>
          </span>
        </a>
      )
    }
    return (
      <a href={"https://twitter.com/" + business.twitter}>
        <span className="social-button" >
          <i className="zmdi zmdi-twitter" style={{ fontSize: 30 }}></i>
        </span>
      </a>
    )
  }

  const facebookButton = (business) => {
    if (isEmpty(business.facebook)) return <></>
    if (business.facebook.startsWith("https")) {
      return (
        <a href={business.facebook}>
          <span className="social-button" >
            <i className="zmdi zmdi-facebook" style={{ fontSize: 30 }}></i>
          </span>
        </a>
      )
    }
    return (
      <a href={"https://facebook.com/" + business.facebook}>
        <span className="social-button" >
          <i className="zmdi zmdi-facebook" style={{ fontSize: 30 }}></i>
        </span>
      </a>
    )
  }

  const whatsappButton = (business) => {
    if (isEmpty(business.whatsapp)) return <></>

    let phone = business.whatsapp
    if (phone.startsWith('+')) phone = phone.slice(1)

    return (
      <a href={"https://wa.me/" + phone}>
        <span className="social-button" >
          <i className="zmdi zmdi-whatsapp" style={{ fontSize: 30 }}></i>
        </span>
      </a>
    )
  }

  const instagramButton = (business) => {
    if (isEmpty(business.instagram)) return <></>
    if (business.instagram.startsWith("https")) {
      return (
        <a href={business.instagram}>
          <span className="social-button" >
            <i className="zmdi zmdi-instagram" style={{ fontSize: 30 }}></i>
          </span>
        </a>
      )
    }
    return (
      <a href={"https://instagram.com/" + business.instagram}>
        <span className="social-button" >
          <i className="zmdi zmdi-instagram" style={{ fontSize: 30 }}></i>
        </span>
      </a>
    )
  }

  const youtubeButton = (business) => {
    if (isEmpty(business.youtube)) return <></>
    if (business.youtube.startsWith("https")) {
      return (
        <a href={business.youtube}>
          <span className="social-button" >
            <i className="zmdi zmdi-youtube" style={{ fontSize: 30 }}></i>
          </span>
        </a>

      )
    }
    return (
      <a href={"https://youtube.com/" + business.youtube}>
        <span className="social-button" >
          <i className="zmdi zmdi-youtube" style={{ fontSize: 30 }}></i>
        </span>
      </a>
    )

  }

  const socialLinksRow = (business) => {
    if (business == null) return <></>

    return (
      <div className="centered">
        <div className="social-row  ">
          <div>
            &nbsp;

          </div>
          <div>
            {twitterButton(business)}
            {facebookButton(business)}
            {whatsappButton(business)}
            {instagramButton(business)}
            {youtubeButton(business)}
          </div>
          <div>
            &nbsp;
          </div>

        </div>
      </div>
    )
  }

  const addStyling = (business) => {

    function _prefixedColour(colour) {
      if (colour.indexOf('#') !== 0) {
        return '#' + colour
      }
      return colour
    }

    function padZero(str, len) {
      len = len || 2;
      var zeros = new Array(len).join('0');
      return (zeros + str).slice(-len);
    }

    function invertColor(hex, bw) {
      if (hex.indexOf('#') === 0) {
        hex = hex.slice(1);
      }
      // convert 3-digit hex to 6-digits.
      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      if (hex.length !== 6) {
        throw new Error('Invalid HEX color.');
      }
      var r = parseInt(hex.slice(0, 2), 16),
        g = parseInt(hex.slice(2, 4), 16),
        b = parseInt(hex.slice(4, 6), 16);
      if (bw) {
        // https://stackoverflow.com/a/3943023/112731
        return (r * 0.299 + g * 0.587 + b * 0.114) > 186
          ? '#000000'
          : '#FFFFFF';
      }
      // invert color components
      r = (255 - r).toString(16);
      g = (255 - g).toString(16);
      b = (255 - b).toString(16);
      // pad each with zeros and return
      return "#" + padZero(r) + padZero(g) + padZero(b);
    }

    let css = document.createElement('style');

    css.innerHTML = `
body {
background-color: #000000;
color: #ffffff;
}
.home-container {
background-color: #000000;
color: #ffffff;
}
.home-container .social-button i {
color: #ffffff;
}
`;


    if (business.style && business.style != "") {
      css.innerHTML = business.style
    } else if (business.colour && business.colour != "") {
      let style = {
        backgroundColor: _prefixedColour(business.colour),
        color: invertColor(business.colour, true)
      }
      css.innerHTML = `
body {
  background-color: ${style.backgroundColor};
  color: ${style.color};
}
.home-container {
background-color: ${style.backgroundColor};
color: ${style.color};
}
.home-container .social-button i {
color: ${style.color};
}
`;
    }

    //console.log("style", css.innerHTML)

    document.head.appendChild(css);

  }

  const getLocalBusinesses = (user, category, city, province, country, onSuccess, onError) => {
    // get local businesses in the given city in the given category
    let url = `/api/v1/business/type/${city}/${province}/${country}/${category}`

    getFromApi(url, user || {}, onSuccess, onError)

  }

  const getLocalOffers = (user, city, province, country, onSuccess, onError) => {
    // get local businesses in the given city in the given category
    let url = `/api/v1/campaign/city/${city}/${province}/${country}`

    getFromApi(url, user || {}, onSuccess, onError)

  }

  const rankBusinessesByLocationRanking = (businesses, city) => {
    // rank businesses by the location ranking
    for (let b of businesses) {
      //console.log("business", b.name, b.uuid.length, b.uuid)
      b.rank = 1000
      if (b.locations.length == 0) continue
      if (b.locations.length == 1) {
        b.rank = b.locations[0].rank
        continue
      }
      b.locations.reduce((acc, loc) => {
        if (loc.rank < b.rank && loc.city == city) b.rank = loc.rank
        return acc
      })
    }
    businesses.sort((a, b) => a.rank - b.rank)

    return businesses
  }

  const appUrl = (business, page) => {
    if (window.location.href.includes("localhost")) {
      return `http://localhost:3008/p/${business.uuid}/${page}`
    }
    // we are using app.zono.cc rather than the business sub-domain
    // so local storage applies to all businesses for the user address list
    return `https://app.zono.cc/p/${business.uuid}/${page}`
  }

  const offersUrl = (business, city, province, country) => {
    if (business == null || business.uuid == null) {
      return `/offers/${city}/${province}/${country}`
    }
    return appUrl(business, "offers")
  }

  const communityUrl = (business, city, province, country) => {
    if (business == null || business.uuid == null) {
      console.log("communityUrl", city, province, country, "returning", `/community/${city}/${province}/${country}`)
      return `/community/${city}/${province}/${country}`
    }
    console.log("communityUrl", city, province, country, "returning", `https://app.zono.cc/p/${business.uuid}/community`)
    return appUrl(business, "community")
  }

  function formatDate(datetime) {
    const options = { year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }
    const df = new Intl.DateTimeFormat('es-CO', options)

    let dt = Date.parse(datetime)

    return df.format(dt)
  }

  return ({
    assetsRow,
    carouselElement,
    fixupPhone,
    fixupEmail,
    generateCode,
    signString,
    isEmpty,
    twitterButton,
    facebookButton,
    formatDate,
    whatsappButton,
    instagramButton,
    youtubeButton,
    addStyling,
    getCurrentUserLocation,
    getLocalBusinesses,
    getLocalOffers,
    communityUrl,
    offersUrl,
    rankBusinessesByLocationRanking,
    socialLinksRow,

    // export API methods
    generateNonce, getFromApi, postToApi, putToApi, deleteToApi, signMap
  })
}

window.BasePage = BasePage